import { useEffect, useState } from 'react';

const Visibility = ({ children, visible }) => {
    const [show, setShow] = useState(visible);

    useEffect(() => {
        if (visible) {
            setShow(true);
        }
    }, [visible]);

    const onTransitionEnd = () => {
        if (!visible) {
            setShow(false);
        }
    };

    if (visible === false) {
        return null;
    }

    return (
        <div
            onTransitionEnd={onTransitionEnd}
            style={{ visibility: show ? 'visible' : 'hidden' }}
        >
            {children}
        </div>
    );
};

export default Visibility;
